import { useEffect } from "react";
import { useLocation } from "wouter";
import { trackGa4PageView } from "@/lib/ga4";

export function GoogleAnalytics() {
  const [location] = useLocation();

  useEffect(() => {
    trackGa4PageView();
  }, [location]);

  return null;
}
